document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('.js-gblock-more');
    links.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const parent = link.closest('.gblock');
            const blocks = parent.querySelectorAll('.gblock__item');
            blocks.forEach((block) => {
                block.classList.toggle('gblock__item--toggle');
            });

        });
    });
});

